import React, { useState } from 'react';
import { MapIcon, LayoutDashboardIcon, HotelIcon, TreesIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function PersonaTabs() {
  const [activeTab, setActiveTab] = useState(0);
  const {
    t
  } = useTranslation();
  const tabKeys = ['personaTabs.tab0Label', 'personaTabs.tab1Label', 'personaTabs.tab2Label', 'personaTabs.tab3Label'];
  const contentKeys = [{
    title: 'personaTabs.content0Title',
    desc: 'personaTabs.content0Desc',
    features: ['personaTabs.content0Feature0', 'personaTabs.content0Feature1', 'personaTabs.content0Feature2']
  }, {
    title: 'personaTabs.content1Title',
    desc: 'personaTabs.content1Desc',
    features: ['personaTabs.content1Feature0', 'personaTabs.content1Feature1', 'personaTabs.content1Feature2']
  }, {
    title: 'personaTabs.content2Title',
    desc: 'personaTabs.content2Desc',
    features: ['personaTabs.content2Feature0', 'personaTabs.content2Feature1', 'personaTabs.content2Feature2']
  }, {
    title: 'personaTabs.content3Title',
    desc: 'personaTabs.content3Desc',
    features: ['personaTabs.content3Feature0', 'personaTabs.content3Feature1', 'personaTabs.content3Feature2']
  }];
  const illustrations = [<div className="relative w-full h-full bg-[#0A0A0A] rounded-2xl border border-white/10 overflow-hidden" data-id="element-151">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:30px_30px]" data-id="element-152"></div>
      <div className="absolute top-[25%] left-[35%] w-3 h-3 rounded-full bg-[#FF6B00] shadow-[0_0_15px_#FF6B00] animate-pulse" data-id="element-153"></div>
      <div className="absolute top-[40%] left-[55%] w-3 h-3 rounded-full bg-[#FF3CAC] shadow-[0_0_15px_#FF3CAC] animate-pulse" style={{
      animationDelay: '0.5s'
    }} data-id="element-154"></div>
      <div className="absolute top-[55%] left-[25%] w-3 h-3 rounded-full bg-[#00E5FF] shadow-[0_0_15px_#00E5FF] animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-155"></div>
      <div className="absolute top-[35%] left-[70%] w-3 h-3 rounded-full bg-[#7B2FFF] shadow-[0_0_15px_#7B2FFF] animate-pulse" style={{
      animationDelay: '1.5s'
    }} data-id="element-156"></div>
      <div className="absolute top-[65%] left-[50%] w-3 h-3 rounded-full bg-[#FFB800] shadow-[0_0_15px_#FFB800] animate-pulse" style={{
      animationDelay: '2s'
    }} data-id="element-157"></div>
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-158">
        <path d="M35 25 L55 40 L25 55 L50 65" fill="none" stroke="url(#routeGrad)" strokeWidth="0.3" strokeDasharray="2 2" opacity="0.4" data-id="element-159" />
        <defs data-id="element-160">
          <linearGradient id="routeGrad" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-161">
            <stop offset="0%" stopColor="#FF6B00" data-id="element-162" />
            <stop offset="100%" stopColor="#00E5FF" data-id="element-163" />
          </linearGradient>
        </defs>
      </svg>
      <div className="absolute bottom-4 left-4 right-4 h-16 rounded-lg bg-white/5 border border-white/10 backdrop-blur-sm p-3 flex items-center gap-3" data-id="element-164">
        <MapIcon className="w-8 h-8 text-white/30" data-id="element-165" />
        <div data-id="element-166">
          <div className="h-3 w-24 bg-white/20 rounded mb-1.5" data-id="element-167"></div>
          <div className="h-2 w-16 bg-white/10 rounded" data-id="element-168"></div>
        </div>
      </div>
    </div>, <div className="relative w-full h-full bg-[#0A0A0A] rounded-2xl border border-white/10 overflow-hidden p-4" data-id="element-169">
      <div className="w-full h-full rounded-xl border border-white/10 bg-[#111] flex flex-col" data-id="element-170">
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10" data-id="element-171">
          <div className="flex gap-2" data-id="element-172">
            <div className="w-2 h-2 rounded-full bg-[#FF3CAC]" data-id="element-173"></div>
            <div className="w-2 h-2 rounded-full bg-[#FFB800]" data-id="element-174"></div>
            <div className="w-2 h-2 rounded-full bg-[#00E5FF]" data-id="element-175"></div>
          </div>
          <div className="h-3 w-20 bg-white/10 rounded" data-id="element-176"></div>
        </div>
        <div className="flex-1 p-4 space-y-3" data-id="element-177">
          <div className="flex gap-3" data-id="element-178">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#FF6B00]/30 to-[#FF3CAC]/30 flex items-center justify-center" data-id="element-179">
              <span className="text-white/60 text-xs font-bold" data-id="element-180">D1</span>
            </div>
            <div className="flex-1" data-id="element-181">
              <div className="h-3 w-3/4 bg-white/15 rounded mb-1.5" data-id="element-182"></div>
              <div className="h-2 w-1/2 bg-white/8 rounded" data-id="element-183"></div>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-184">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#7B2FFF]/30 to-[#2563EB]/30 flex items-center justify-center" data-id="element-185">
              <span className="text-white/60 text-xs font-bold" data-id="element-186">D2</span>
            </div>
            <div className="flex-1" data-id="element-187">
              <div className="h-3 w-2/3 bg-white/15 rounded mb-1.5" data-id="element-188"></div>
              <div className="h-2 w-2/5 bg-white/8 rounded" data-id="element-189"></div>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-190">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#00E5FF]/30 to-[#2563EB]/30 flex items-center justify-center" data-id="element-191">
              <span className="text-white/60 text-xs font-bold" data-id="element-192">D3</span>
            </div>
            <div className="flex-1" data-id="element-193">
              <div className="h-3 w-4/5 bg-white/15 rounded mb-1.5" data-id="element-194"></div>
              <div className="h-2 w-1/3 bg-white/8 rounded" data-id="element-195"></div>
            </div>
          </div>
          <div className="mt-4 grid grid-cols-2 gap-3" data-id="element-196">
            <div className="h-14 rounded-lg bg-white/5 border border-white/10 p-2" data-id="element-197">
              <div className="h-2 w-12 bg-white/15 rounded mb-1" data-id="element-198"></div>
              <div className="h-4 w-8 bg-gradient-to-r from-[#FF6B00] to-[#FFB800] rounded text-[8px] text-white flex items-center justify-center font-bold" data-id="element-199">
                €
              </div>
            </div>
            <div className="h-14 rounded-lg bg-white/5 border border-white/10 p-2" data-id="element-200">
              <div className="h-2 w-10 bg-white/15 rounded mb-1" data-id="element-201"></div>
              <div className="h-4 w-8 bg-gradient-to-r from-[#00E5FF] to-[#2563EB] rounded text-[8px] text-white flex items-center justify-center font-bold" data-id="element-202">
                %
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>, <div className="relative w-full h-full bg-[#0A0A0A] rounded-2xl border border-white/10 overflow-hidden" data-id="element-203">
      <div className="absolute inset-0 bg-gradient-to-b from-[#FFB800]/5 via-transparent to-[#00E5FF]/5" data-id="element-204"></div>
      <div className="absolute top-6 left-1/2 -translate-x-1/2 w-20 h-20 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-205">
        <HotelIcon className="w-10 h-10 text-white/20" data-id="element-206" />
      </div>
      <div className="absolute top-[20%] left-[15%] w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-207">
        <span className="text-[10px] text-white/30" data-id="element-208">🍽️</span>
      </div>
      <div className="absolute top-[15%] right-[15%] w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-209">
        <span className="text-[10px] text-white/30" data-id="element-210">🏖️</span>
      </div>
      <div className="absolute top-[50%] left-[10%] w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-211">
        <span className="text-[10px] text-white/30" data-id="element-212">🥾</span>
      </div>
      <div className="absolute top-[50%] right-[10%] w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-213">
        <span className="text-[10px] text-white/30" data-id="element-214">🎭</span>
      </div>
      <div className="absolute bottom-[25%] left-[20%] w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-215">
        <span className="text-[10px] text-white/30" data-id="element-216">🏛️</span>
      </div>
      <div className="absolute bottom-[25%] right-[20%] w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-217">
        <span className="text-[10px] text-white/30" data-id="element-218">🌊</span>
      </div>
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-219">
        <line x1="50" y1="30" x2="20" y2="25" stroke="white" strokeWidth="0.2" opacity="0.1" strokeDasharray="1 1" data-id="element-220" />
        <line x1="50" y1="30" x2="80" y2="20" stroke="white" strokeWidth="0.2" opacity="0.1" strokeDasharray="1 1" data-id="element-221" />
        <line x1="50" y1="30" x2="15" y2="55" stroke="white" strokeWidth="0.2" opacity="0.1" strokeDasharray="1 1" data-id="element-222" />
        <line x1="50" y1="30" x2="85" y2="55" stroke="white" strokeWidth="0.2" opacity="0.1" strokeDasharray="1 1" data-id="element-223" />
      </svg>
    </div>, <div className="relative w-full h-full bg-[#0A0A0A] rounded-2xl border border-white/10 overflow-hidden" data-id="element-224">
      <div className="absolute inset-0 bg-gradient-to-b from-[#7B2FFF]/8 via-transparent to-[#FF6B00]/8" data-id="element-225"></div>
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 200 150" preserveAspectRatio="none" data-id="element-226">
        <path d="M0 100 Q50 60 100 80 Q150 100 200 70 L200 150 L0 150 Z" fill="rgba(255,255,255,0.03)" data-id="element-227" />
        <path d="M0 110 Q60 80 120 95 Q160 110 200 90 L200 150 L0 150 Z" fill="rgba(255,255,255,0.02)" data-id="element-228" />
        <circle cx="160" cy="30" r="12" fill="rgba(255,184,0,0.15)" data-id="element-229" />
      </svg>
      <div className="absolute bottom-4 left-4 right-4 flex gap-3" data-id="element-230">
        <div className="flex-1 h-20 rounded-lg bg-white/5 border border-white/10 p-3" data-id="element-231">
          <TreesIcon className="w-5 h-5 text-white/20 mb-1" data-id="element-232" />
          <div className="h-2 w-12 bg-white/10 rounded" data-id="element-233"></div>
        </div>
        <div className="flex-1 h-20 rounded-lg bg-white/5 border border-white/10 p-3" data-id="element-234">
          <div className="w-5 h-5 text-white/20 mb-1 text-sm" data-id="element-235">🏔️</div>
          <div className="h-2 w-10 bg-white/10 rounded" data-id="element-236"></div>
        </div>
        <div className="flex-1 h-20 rounded-lg bg-white/5 border border-white/10 p-3" data-id="element-237">
          <div className="w-5 h-5 text-white/20 mb-1 text-sm" data-id="element-238">☕</div>
          <div className="h-2 w-14 bg-white/10 rounded" data-id="element-239"></div>
        </div>
      </div>
    </div>];
  return <section className="py-24 bg-[#050505] relative z-20" data-id="element-240">
      <div className="max-w-7xl mx-auto px-6" data-id="element-241">
        <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-242">
          {t('personaTabs.sectionTitle')}
        </h2>

        <div className="flex flex-wrap justify-center gap-2 md:gap-8 mb-16 border-b border-white/10" data-id="element-243">
          {tabKeys.map((key, idx) => <button key={idx} type="button" onClick={() => setActiveTab(idx)} className={`relative pb-4 px-4 text-sm md:text-base font-medium transition-colors duration-300 ${activeTab === idx ? 'text-white' : 'text-white/40 hover:text-white/70'}`} data-id="element-244">
              {t(key)}
              {activeTab === idx && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-animated rounded-t-full" data-id="element-245"></div>}
            </button>)}
        </div>

        <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl p-8 md:p-16 min-h-[300px] flex items-center relative overflow-hidden" data-id="element-246">
          {contentKeys.map((item, idx) => <div key={idx} className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center w-full transition-opacity duration-500 absolute inset-0 p-8 md:p-16 ${activeTab === idx ? 'opacity-100 z-10 relative' : 'opacity-0 z-0 pointer-events-none'}`} data-id="element-247">
              <div data-id="element-248">
                <h3 className="text-3xl font-bold mb-6" data-id="element-249">{t(item.title)}</h3>
                <p className="text-white/60 text-lg mb-8 leading-relaxed" data-id="element-250">
                  {t(item.desc)}
                </p>
                <ul className="space-y-4" data-id="element-251">
                  {item.features.map((featureKey, i) => <li key={i} className="flex items-center text-white/80" data-id="element-252">
                      <div className="w-2 h-2 rounded-full bg-gradient-animated mr-4 shrink-0" data-id="element-253"></div>
                      {t(featureKey)}
                    </li>)}
                </ul>
              </div>
              <div className="relative h-64 md:h-full min-h-[300px]" data-id="element-254">
                {illustrations[idx]}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}